import { render } from "./HandleReportView.vue?vue&type=template&id=63941e18&ts=true"
import script from "./HandleReportView.vue?vue&type=script&lang=ts"
export * from "./HandleReportView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__